import { Document } from './document';
import { Branch } from './branch';

export abstract class Node extends Document {
    public static _type: string = 'Node';
    public static prefixNew: string = '_';

    public original?: string;

    public isNew?: boolean;
    public isDirty?: boolean;

    public parentId?: string;
    public parent?: Branch;

    public _system: boolean = false;

    public get model(): any{
        const { _, isNew, isDirty, original, parent, ...model } = this;

        if (this.isNew) {
            delete model._id;
        }

        for(const key in model) {
            if (key.startsWith('i_'))
                delete model[key as keyof typeof model];
        }

        return model;
    }

    public newId(id: string): void {
        if (id) {
            this._id = `${Node.prefixNew + id}`;
            this._ = this._id;

            this.isNew = true;
            this.isDirty = true;
        }
    }

    public accept(id: string): void {
        if (this.isNew) {
            delete this.isNew;
            this._id = id;
        }

        this.isDirty = undefined;
        this.original = this.name;
    }

    public constructor(source?: any) {
        super(source);

        if (source) {
            this.parentId = source.parentId;
            this.original = source.name;
            this._system = source._system;
        }
    }

    public override copy(source?: any): void {
        super.copy(source);

        if (source) {
            this.parentId = source.parentId;
            this.original = source.name;
            this._system = source._system;
        }
    }

    public contains(node: Node): boolean {
        if (!(this instanceof Branch)){
            return false;
        }

        let branch = node.parent;
        while(branch) {
            if (this === branch) {
                return true;
            }
            branch = branch.parent;
        }
        return false;
    }

    public childOf(node: Node): boolean {
        return this.cascadeChild(this, node);
    }

    private cascadeChild(parent: Node, child: Node): boolean {
        return !parent || !child ?
        false : parent === child ?
        true : !child.parent ?
        false : this.cascadeChild(parent, child.parent);
    }

    public load(source?: any): void {
        this.copy(source);
    }

    public abstract fit(branch: Branch): boolean;
}


